import { render, staticRenderFns } from "./Enterprise_number.vue?vue&type=template&id=120a8c56&scoped=true"
import script from "./Enterprise_number.vue?vue&type=script&lang=js"
export * from "./Enterprise_number.vue?vue&type=script&lang=js"
import style0 from "./Enterprise_number.vue?vue&type=style&index=0&id=120a8c56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a8c56",
  null
  
)

export default component.exports